import {IDropdownMenuItem} from '@atomaro/ui-kit/components/DropdownMenu/types';
import {IDictionary} from 'shared/types/common.ts';

export const notifySelectItems: IDropdownMenuItem[] = [
  {
    key: 'null',
    value: 'Нет',
  },
  {
    key: -60000,
    value: 'В момент события',
  },
  {
    key: -300000,
    value: 'За 5 минут',
  },
  {
    key: -600000,
    value: 'За 10 минут',
  },
  {
    key: -900000,
    value: 'За 15 минут',
  },
  {
    key: -1.8e6,
    value: 'За 30 минут',
  },
  {
    key: -3.6e6,
    value: 'За 1 час',
  },
  {
    key: -7.2e6,
    value: 'За 2 часа',
  },
  {
    key: -8.64e7,
    value: 'За 1 день',
  },
  {
    key: -1.728e8,
    value: 'За 2 дня',
  },
  {
    key: -6.048e8,
    value: 'За 1 неделю',
  },
];

export const YANDEX_TOKEN = import.meta.env.VITE_YANDEX_TOKEN;

export const NAME_DICTIONARIES: Record<IDictionary['type'], string> = {
  DIARY: 'Состояния ульев',
  UTERUS_MARK: 'Метки матки',
  UTERUS_BREED: 'Породы матки',
};
